import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function OntologyIcon(props) {

    let filterProps = Object.assign({}, props);
    delete filterProps.iconColor;

    return (
        <SvgIcon {...filterProps} viewBox={"0 0 17 19"}>
            <path id="Path_1459"
                data-name="Path 1459"
                d="M15,7.784a3,3,0,0,0-2.741,1.741L8.883,9.291,8.364,5.505A2.9,2.9,0,0,0,10,2.919,2.96,2.96,0,0,0,7,0,2.96,2.96,0,0,0,4,2.919,2.939,2.939,0,0,0,6.383,5.775L6.9,9.525l-2.669,2.9A3.041,3.041,0,0,0,3,12.162,2.92,2.92,0,1,0,3,18a2.96,2.96,0,0,0,3-2.919,2.817,2.817,0,0,0-.331-1.306l2.386-2.591,4.061.28A2.984,2.984,0,1,0,15,7.784Z"
                fill={props.iconColor || '#ffffff'} />
        </SvgIcon>
    );
}

export default OntologyIcon;